module.exports = __webpack_public_path__ + "static/media/GABA_Post_2018.09.26.0429fefa.jpg";